import { reactive } from "vue";

const eventBus = reactive({
  events: {},
  emit(event, payload) {
    if (this.events[event]) {
      this.events[event](payload);
    }
  },
  on(event, callback) {
    this.events[event] = callback;
  },
  off(event) {
    delete this.events[event];
  },
});

export default eventBus;
